__turbopack_context__.v({
  "className": "_82dDtq_className",
  "variable": "_82dDtq_variable",
});
